/* Explicit EUR/Romanian links, initial GeoIP selection and native Shopify localization. */
(() => {
  'use strict';
  const PREF = 'rocos_localization_preference_v1';
  const STATE = 'rocos_localization_state_v1';
  const SUPPORTED = {RO:'ro', DE:'de', ES:'es', IT:'it'};
  const EUR_LANGUAGES = ['de','es','it'];
  const read = key => { try { return JSON.parse(localStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } };

  function decide(current, geoCountry, options) {
    const countries = options.countries;
    const isEur = country => countries[country] === 'EUR';
    const explicitCountry = countries[options.explicitCountry] ? options.explicitCountry : null;
    let country = current.country, locale = current.locale;
    let reason = 'existing_selection';
    if (options.initial && !options.manual && !explicitCountry && SUPPORTED[geoCountry] && countries[geoCountry]) {
      country = geoCountry;
      locale = options.explicitLocale || SUPPORTED[geoCountry];
      reason = 'geoip_first_visit';
    }
    if (explicitCountry) country = explicitCountry;
    if (EUR_LANGUAGES.includes(locale) && !isEur(country)) {
      if (isEur(current.country)) country = current.country;
      else if (isEur(geoCountry)) country = geoCountry;
      else if (options.fallback === 'language_country' && isEur(locale.toUpperCase())) country = locale.toUpperCase();
      else return {needsCountry:true, locale, reason:'eur_country_required'};
      reason = 'eur_language_rule';
    }
    return {country, locale, reason, change:country !== current.country || locale !== current.locale};
  }
  window.RocosLocalizationPolicy = {decide};
  const element = document.getElementById('rocos-localization-settings');
  if (!element || window.rocosLocalization || window.Shopify?.designMode || location.origin !== 'https://rocos.ro') return;
  let config;
  try { config = JSON.parse(element.textContent); } catch { return; }
  if (!config.countries || !config.current || !SUPPORTED[config.current.country]) return;
  if (/\/(?:account|checkout|checkouts|challenge)(?:\/|$)/.test(location.pathname)) return;
  const entryUrl = new URL(location.href);
  const explicitEuro = (entryUrl.searchParams.get('currency') || '').toUpperCase() === 'EUR';
  if (!explicitEuro && /bot\b|crawler|spider|facebookexternalhit|bingpreview/i.test(navigator.userAgent)) return;
  const form = document.getElementById('rc-auto-localization');
  if (!form) return;
  let userChoice = Boolean(window.rocosLocalizationUserChoice);
  let started = false;
  const status = {phase:'ready', country:config.current.country, locale:config.current.locale};
  window.rocosLocalization = {status};
  const current = config.current;

  function manual(event) {
    const target = event.target;
    if (!(target instanceof HTMLFormElement) || !target.closest('[data-rc-localization]')) return;
    userChoice = true;
    window.rocosLocalizationUserChoice = true;
    const country = target.querySelector('[name="country_code"]')?.value;
    const locale = target.querySelector('[name="language_code"]')?.value;
    if (config.countries[country] && Object.values(SUPPORTED).includes(locale)) {
      write(PREF, {...(read(PREF) || {}), country, locale, source:'manual', at:Date.now()});
      write(STATE, {country, locale, source:'manual', phase:'pending', at:Date.now()});
    }
    status.phase = 'manual_selection';
  }
  document.addEventListener('submit', manual, true);
  function destination(locale = null) {
    const url = new URL(location.href);
    if (locale && locale !== current.locale) {
      const alternate = document.querySelector('link[rel="alternate"][hreflang="' + locale + '"]');
      if (alternate) {
        const localized = new URL(alternate.href, location.href);
        if (localized.origin === location.origin) url.pathname = localized.pathname;
      }
    }
    for (const key of ['country','country_code','currency','language','language_code','locale']) url.searchParams.delete(key);
    return url.pathname + url.search + url.hash;
  }
  function submit(target, explicit = false) {
    if (userChoice || window.rocosLocalizationUserChoice) return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/localization$/.test(action.pathname)) return;
    if (!write(STATE, {country:target.country, locale:target.locale, phase:'pending', source:target.reason, at:Date.now()}) && !explicit) {
      status.phase = 'storage_unavailable'; return;
    }
    form.querySelector('[name="country_code"]').value = target.country;
    form.querySelector('[name="language_code"]').value = target.locale;
    form.querySelectorAll('[name="return_to"]').forEach(input => { input.value = destination(explicit ? target.locale : null); });
    Object.assign(status, {phase:'submitting', country:target.country, locale:target.locale, reason:target.reason});
    console.info('[Rocos Localizare]', target.reason, target.country, target.locale);
    HTMLFormElement.prototype.submit.call(form);
  }
  async function start() {
    if (started) return;
    started = true;
    // A campaign/feed link is a new explicit choice, ahead of stored preferences,
    // past detection failures and GeoIP. Shopify handles currency=EUR natively;
    // the localization form also translates the current route to Romanian.
    if (explicitEuro) {
      if (userChoice || window.rocosLocalizationUserChoice) return;
      // Match the existing EURO selector: keep an EUR country when available,
      // otherwise use the first EUR country exposed by Shopify.
      const country = config.countries[current.country] === 'EUR' ? current.country
        : Object.keys(config.countries).find(code => config.countries[code] === 'EUR');
      if (!country) { status.phase = 'eur_country_unavailable'; return; }
      const target = {country, locale:'ro', reason:'explicit_eur_link'};
      write(PREF, {country, locale:'ro', currencyPreference:'EUR', source:target.reason, at:Date.now()});
      if (current.locale === 'ro' && current.currency === 'EUR' && current.country === country) {
        write(STATE, {country, locale:'ro', phase:'complete', source:target.reason, at:Date.now()});
        Object.assign(status, {phase:'complete', country, locale:'ro', reason:target.reason});
        // Consume the request so a later manual selection is free to change it.
        try { history.replaceState(history.state, '', destination()); } catch {}
      } else {
        // return_to consumes the parameter, preventing redirect loops even when
        // localStorage is unavailable. Native Shopify cookies retain the choice.
        submit(target, true);
      }
      return;
    }
    const previous = read(STATE);
    const preference = read(PREF);
    if (previous?.phase === 'pending') {
      const matched = previous.country === current.country && previous.locale === current.locale;
      write(STATE, {...previous, phase:matched ? 'complete' : 'failed', checked_at:Date.now()});
      status.phase = matched ? 'complete' : 'stopped_after_incomplete_change';
      // A failed or interrupted submission is never repeated automatically.
      if (!matched) return;
    }
    if (previous?.phase === 'failed') { status.phase = 'stopped_after_incomplete_change'; return; }
    const url = new URL(location.href);
    const explicitLocale = /^\/(de|es|it)(?:\/|$)/.exec(url.pathname)?.[1] || null;
    const explicitCountry = (url.searchParams.get('country') || url.searchParams.get('country_code') || '').toUpperCase();
    const initial = !preference && !previous;
    const requiresEuro = EUR_LANGUAGES.includes(current.locale) && current.currency !== 'EUR';
    if (!initial && !requiresEuro) { status.phase = preference ? 'manual_preference_kept' : 'complete'; return; }
    status.phase = 'detecting';
    const data = typeof window.rocosGeoIPDebug === 'function' ? await window.rocosGeoIPDebug() : null;
    if (userChoice || window.rocosLocalizationUserChoice) return;
    // Another tab may have made a manual choice while this request was pending.
    if (JSON.stringify(read(PREF)) !== JSON.stringify(preference)) {
      status.phase = 'manual_preference_kept'; return;
    }
    if (!previous && read(STATE)) {
      status.phase = 'selection_in_another_tab'; return;
    }
    const target = decide(current, data?.country || null, {countries:config.countries, initial,
      manual:Boolean(preference), explicitLocale, explicitCountry, fallback:config.fallback});
    if (target.needsCountry) {
      status.phase = 'country_selection_required';
      const selector = document.querySelector('[data-rc-market]');
      if (selector) selector.open = true;
      return;
    }
    if (target.change) submit(target);
    else {
      // Transient detection failures stay eligible on a later visit after the GeoIP cooldown.
      if (data || !initial) write(STATE, {country:current.country, locale:current.locale, phase:'complete', source:target.reason, at:Date.now()});
      status.phase = data ? 'complete' : 'geoip_unavailable';
    }
  }
  void start().catch(() => { status.phase = 'unavailable'; });
})();
